/**
 * Created by Aleksandr on 06.10.2022.
 */

const Plinga = function () {
    Platform.call(this, connector.PLINGA, {
        sdk: SdkManager.SDK_PLINGA
    });

    connector._gdComOldId = connector.utils.getRequestParameters().gdcom_userid;
};

Plinga.prototype = Object.create(Platform.prototype);
Plinga.prototype.constructor = Plinga;

Plinga.prototype.loadUserId = function () {
    this._userID = connector.dataLoader.load(SimpleDataLoader.TYPES.USER_ID);
    if (!this._userID) {
        if (connector._gdComOldId) {
            this.setUserID(connector._gdComOldId);
        } else {
            this.setUserID(this.generateTmpId());
        }
    }
};

Plinga.prototype._connect = function (callback) {
    // eslint-disable-next-line no-unused-vars, camelcase
    plingaRpc_pauseGame = () => this._toggleSdkPaused(true);

    // eslint-disable-next-line no-unused-vars, camelcase
    plingaRpc_resumeGame = () => this._toggleSdkPaused(false);

    plingaRpc.setAllowFullscreen();

    callback(connector.STATUS_CONNECTED);
};

Plinga.prototype.getLocalStoragePrefix = function () {
    return "_plinga";
};